import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS11 = props => {
    const ans = '焦慮行為'
    const select_arr = [
        {
            value: '1',
            label: '無'
        },
        {
            value: '2',
            label: '表情緊張'
        },
        {
            value: '3',
            label: '發抖'
        },
        {
            value: '4',
            label: '胸痛'
        },
        {
            value: '5',
            label: '坐立不安'
        },
        {
            value: '6',
            label: '玩弄東西'
        },
        {
            value: '7',
            label: '肚子痛'
        },
        {
            value: '8',
            label: '頭痛'
        },
        {
            value: '9',
            label: '思考障礙'
        },

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s11"
                   type="checkbox"/>
        </div>
    )
}

export default SseS11


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS11.jsx